import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { throwError, catchError, retry, of, switchMap } from 'rxjs';
import { AuthService } from 'addiction-auth';

export const ErrorInterceptor: HttpInterceptorFn = (req, next) => {
    const authService = inject(AuthService);
    return next(req).pipe(
        catchError((err) => {
            if (err.status === 401) {
                //if 401 try first to refresh
                return authService.tryToRefreshToken().pipe(
                    switchMap(() => {
                        const clonedReq = req.clone({
                            setHeaders: {
                                'Content-Type': 'application/json',
                                Authorization: 'Bearer ' + authService.idToken,
                            },
                        });
                        return next(clonedReq);
                    }),
                    catchError((err) => {
                        // auto logout if 401 response returned from api
                        authService.logout();
                        return throwError(() => new Error('unauthorized'));
                    })
                );
            }
            return throwError(() => err);
        }),
        retry({
            //prova un retry
            count: 1,
            delay: 500,
            resetOnSuccess: false, //non metterlo a true (non sappiamo bene il perchè ma va in loop)
        })
    );
};
